module.exports = __webpack_public_path__ + "img/P150T_weapon_53.05198fa7.png";